import { render, staticRenderFns } from "./CaseRecord.vue?vue&type=template&id=7c2ebf95&scoped=true&"
import script from "./CaseRecord.vue?vue&type=script&lang=js&"
export * from "./CaseRecord.vue?vue&type=script&lang=js&"
import style0 from "./CaseRecord.vue?vue&type=style&index=0&id=7c2ebf95&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2ebf95",
  null
  
)

export default component.exports